import { EMAIL_REGEX } from "./validation";

export function isValidEmail(email: string) {
  return EMAIL_REGEX.test(email);
}
